// Usage: https://github.com/feathericons/feather#usage
import feather from 'feather-icons';

document.addEventListener('DOMContentLoaded', function() {
    feather.replace();
});
